/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    4000: "Exploitation day isn't active.",
    4001: "Line proxy isn't active.",
    4002: "Missing data in the line proxy.",
    4003: "SAE identifier isn't correct for the DSP.",
    4004: "DSP is inactive on day."
};